/**
 * Column picker + local persistence for Feedback list (see Feedback.js).
 * Default view: Sl.No (locked) + type, status, description, device id, error code.
 */
/** API / row field names in stable column order (Sl.No is synthetic and listed separately in columnSequence). */
const FEEDBACK_DATA_KEYS = [
  "createdAt",
  "updatedAt",
  "status",
  "type",
  "deviceBrand",
  "deviceCategory",
  "deviceId",
  "mobile",
  "description",
  "comments",
  "errorCode",
  "appVersion",
  "mobileOSVersion",
  "mobileName",
  "mobileModel",
  "mobileOSBuildNumber",
  "feedbackId",
];

/** Shown first after Sl.No; matches product default “type, status, desc, device id, error code”. */
const PRIORITY_KEYS = ["type", "status", "description", "deviceId", "errorCode"];

/** Merged in Feedback.js with per-column labels and flags; key must match localStorage clears on logout. */
export const FEEDBACK_TABLE_BASE = {
  storageType: "local",
  /** Must stay in sync with auth.js / tokenRefresh.js removeItem keys. */
  sessionStorageKey: "feedback.visibleColumns",
  lockedColumns: ["slNo"],
  defaultVisibleColumns: ["slNo", ...PRIORITY_KEYS],
  /** Full pick list order in the Columns dialog; slNo + priority keys appear first. */
  columnSequence: [
    "slNo",
    ...PRIORITY_KEYS,
    ...FEEDBACK_DATA_KEYS.filter((k) => !PRIORITY_KEYS.includes(k)),
  ],
};
